import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  <span style="color:#a6d189;">**{quantity}**</span> toodet

  <span style="color:#85c1dc;">**FI:**</span>
  <span style="color:#a6d189;">**{quantity}**</span> tuotteet

  <span style="color:#85c1dc;">**RU:**</span>
  <span style="color:#a6d189;">**{quantity}**</span> товаров
*/
/* @__NO_SIDE_EFFECTS__ */
const m38 = msg(
  mf`${'quantity'} toodet`,
  mf`${'quantity'} tuotteet`,
  mf`${'quantity'} товаров`,
)

export { m38 as 'w.basket.products_in_basket_plural' }